// @flow

import type {IT} from './imports/ITest'

class MyClass {
    constructor(it: IT) {}
}
